var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"md":24,"sm":24}},[_c('a-card',{attrs:{"bordered":false}},[_c('a-row',{staticStyle:{"height":"100%","margin":"0px"},attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":24}},[_c('a-spin',{attrs:{"tip":"Loading...","spinning":_vm.loading}},[_c('div',{attrs:{"id":"video"}})])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }